import { render, staticRenderFns } from "./AppAside.vue?vue&type=template&id=d805b124"
import script from "./AppAside.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppAside.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./AppAside.vue?vue&type=style&index=0&id=d805b124&prod&module=true&lang=stylus"
import style1 from "./AppAside.vue?vue&type=style&index=1&id=d805b124&prod&lang=stylus"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports